import React from 'react'

const AppraiserHeader = ({ appraiserInfo }) =>
  <div className='appraisal-workspace-header'>
    {appraiserInfo.fetching && <div>Loading...</div>}
    {appraiserInfo && !appraiserInfo.error && !appraiserInfo.fetching &&
      <div className='appraisal-workspace-header'>
        <div className='appraisal-workspace-header-row'>
          <span><b>Appraiser Name:</b> {appraiserInfo.firstName} {appraiserInfo.middleName ? appraiserInfo.middleName + ' ' : ''}{appraiserInfo.lastName}</span>
          <span><b>Appraiser ID:</b> {appraiserInfo.appraiserVaId}</span>
        </div>
        <div className='appraisal-workspace-header-row'>
          <span><b>Appraiser Status:</b> {appraiserInfo.appraiserStatus}</span>
          <span><b>Appraiser Availability Status:</b> {appraiserInfo.availabilityStatus === 'Y' ? 'Available' : 'Unavailable'}</span>
        </div>
      </div>}
    {appraiserInfo.error && <div>Error: Unable to load appraiser information.</div>}
  </div>

export default AppraiserHeader
